import { CSS as DepartmentSelectorCSS } from '../../modules/department.selector/department.selector.style';
import { CSS as OmniSearchCSS } from '../../modules/omni.search/omni.search.style';
import { addStyles, DefaultTheme } from '../theme';

export const MDL = {
	button: 'mdl-button',
	title: 'mdl-layout-title',
	spacer: 'mdl-layout-spacer',
	drawer: {
		button: 'mdl-layout__drawer-button',
	},
};

export const CSS = {
	header: {
		container: 'c-Header',
		row: 'c-Header_row',
		section: 'c-Header__section',
		sectionRight: 'c-Header__section--right',
	},
	drawer: {
		button: 'c-DrawerButton',
	},
	user: {
		menu: 'c-UserMenu',
		spacer: 'c-UserMenu__spacer',
		name: 'c-UserMenu__name',
		email: 'c-UserMenu__email',
		card: 'c-UserMenu__card',
	},
};

const SPACE_10 = DefaultTheme.space(10);
const SPACE_8 = DefaultTheme.space(8);
const SPACE_7 = DefaultTheme.space(7);

addStyles({
	[CSS.header.container]: {
		height: SPACE_10,
		'min-height': SPACE_10,
		width: '100%',
		'background-color': DefaultTheme.background.darkGrey,
		color: 'rgba(255,255,255,0.97)',
		[`& .${OmniSearchCSS.container}`]: {
			flex: '1',
			height: SPACE_7,
		},
		[`& .${DepartmentSelectorCSS.container}`]: {
			'margin-left': '90px',
		},
	},
	[CSS.header.row]: {
		display: 'flex',
		'flex-direction': 'row',
		'align-items': 'center',
		height: SPACE_10,
		'padding-right': DefaultTheme.space(2),
		'min-height': SPACE_10,
		'background-color': DefaultTheme.background.darkGrey,
		color: 'rgba(255,255,255,0.97)',
		[`& .${MDL.title}`]: {
			'white-space': 'nowrap',
			'margin-right': DefaultTheme.space(2),
		},
		[`& .c-Button > i, & .${DepartmentSelectorCSS.container} i`]: {
			color: DefaultTheme.font.color.white,
		},
	},
	[CSS.header.section]: {
		display: 'flex',
		flex: 1,
		'align-items': 'center',
	},
	[CSS.header.sectionRight]: {
		'justify-content': 'flex-end',
	},
	[CSS.drawer.button]: {
		height: SPACE_8,
		width: SPACE_8,
		'min-height': SPACE_8,
		margin: DefaultTheme.space(1) + ' ' + DefaultTheme.space(3),
		// fallback to /images/favicon.svg for local development
		'background-size': 'contain',
		'background-repeat': 'no-repeat',
		cursor: 'pointer',
		'flex-shink': 0,
		'-webkit-flex-shrink': 0,
	},
	[CSS.user.menu]: {
		color: DefaultTheme.font.color.primary,
		'whites-space': 'no-wrap',
		'user-select': 'none',
	},
	[CSS.user.card]: {
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
		'background-color': DefaultTheme.background.lightGrey,
		'line-height': DefaultTheme.space(8),
		'margin-top': DefaultTheme.space(-2),
		padding: `${DefaultTheme.space(2)} 0`,
		'&[disabled]': {
			'background-color': DefaultTheme.background.lightGrey,
		},
		'&[disabled]:hover': {
			'background-color': DefaultTheme.background.lightGrey,
		},
	},
	[CSS.user.name]: {
		color: DefaultTheme.font.color.primary,
		padding: `0 ${DefaultTheme.space(4)}`,
	},
	[CSS.user.email]: {
		color: DefaultTheme.font.color.supporting,
		padding: `0 ${DefaultTheme.space(4)}`,
		'line-height': DefaultTheme.space(4),
	},
	[CSS.user.spacer]: {
		height: DefaultTheme.space(3),
		'line-height': DefaultTheme.space(3),
	},
});
